import { render, staticRenderFns } from "./PodtEditAppr.vue?vue&type=template&id=74788e80&scoped=true&"
import script from "./PodtEditAppr.vue?vue&type=script&lang=js&"
export * from "./PodtEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74788e80",
  null
  
)

export default component.exports